import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Menu, Executions, FirmList, Reports } from './';

import { cs2Actions } from '../_actions';

import dateFormat from 'dateformat';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function SelectionCriteria() {
    const user = useSelector(state => state.authentication.user);
    const dispatch = useDispatch();
    
    const [tradeDate, setTradeDate] = useState(new Date());
    

    function handleTradeDateChanges(tdate) {
    	
    setTradeDate(tdate);
   	 
   	 console.log("------------------- handleTradeDateChanges -------------------" + tdate);  
   	 console.log("------------------- handleTradeDateChanges -------------------" + dateFormat(tdate, "yyyymmdd"));
   	  
        dispatch(cs2Actions.cs2Executions(dateFormat(tdate, "yyyymmdd")));
        
    }
    

    return (
    		<div className="row">
	    		<div className="col-sm-8" >
	    			<h3>CS2 Executions</h3>
	    			{alert.message &&
			            <div className={`alert ${alert.type}`}>{alert.message}</div>
			        }
	    		</div>
	    		<div className="col-sm-2 text-right" >
	    			<h5>Trade Date </h5>
	    		</div>
	    		<div className="col-sm-2 text-right" >
					<DatePicker selected={tradeDate} dateFormat="MM/dd/yyyy" onChange={(date) => handleTradeDateChanges(date)  }  portalId="root"
						popperClassName="ag-custom-component-popup"/>
				</div>
	    	</div>
    );
}

export { SelectionCriteria };